import styled from 'styled-components';
import CloseIconSvg from './../assets/closeIcon.svg';

const CloseIcon = styled(CloseIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  fill: ${props => props.fill};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default CloseIcon;
